import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IServicio, IDeleteServicioResponse, IUpdateServicioResponse } from '../../interfaces/servicios.interface';
import {
  CreateServicio, CreateServicioSuccess, DeleteServicio, DeleteServicioSuccess,
  GetServicios, GetServiciosSuccess, UpdateServicio, UpdateServicioSuccess
} from '../actions/servicios.actions';

@Injectable()
export class ServiciosEffects {
  getServicios$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetServicios),
      switchMap(() =>
        this.apiService.getServicios().pipe(
          map((servicios: IServicio[]) => GetServiciosSuccess({ servicios }))
        )
      )
    )
  );

  createServicio$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateServicio),
      switchMap(payload =>
        this.apiService.createServicio(payload.servicio).pipe(
          map((servicio: IServicio) => CreateServicioSuccess({ servicio }))
        )
      )
    )
  );

  deleteServicio$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteServicio),
      switchMap(payload =>
        this.apiService.deleteServicio(payload.id).pipe(
          map((servicio: IDeleteServicioResponse) => DeleteServicioSuccess({ servicio }))
        )
      )
    )
  );

  updateServicio$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateServicio),
      switchMap(payload =>
        this.apiService.updateServicio(payload.id, payload.servicio).pipe(
          map((servicio: IUpdateServicioResponse) => UpdateServicioSuccess({ servicio }))
        )
      )
    )
  );

  constructor(
    private apiService: ApiService,
    private actions$: Actions,
    private store: Store<IAppState>
  ) { }
}
